(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-account-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (!root || root.dataset.mpBound) return;
    root.dataset.mpBound = 'true';
    const panels = [...root.querySelectorAll('[data-mp-query]')];
    const message = (key) => root.querySelector(`[data-mp-message="${key}"]`)?.content.textContent.trim() || '';
    const state = { next: root.querySelector('[data-mp-pagination]')?.dataset.nextUrl || '', total: Number(root.dataset.orderCount), busy: false, failed: false, key: root.dataset.customerKey, retry: null, controller: null };
    const storageKey = 'mp-account-query-intent-v2';
    const normalize = (value) => value.normalize('NFKC').trim().toLocaleLowerCase().replace(/^#/, '');
    const currentUrl = (mode) => {
      const url = new URL(root.dataset.accountUrl, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      url.hash = mode;
      return url;
    };
    const setStatus = (text) => panels.forEach(p => { p.querySelector('[data-mp-query-status]').textContent = text; });
    const setBusy = (busy) => {
      state.busy = busy;
      panels.forEach(p => {
        p.setAttribute('aria-busy', String(busy));
        p.querySelectorAll('button[type="submit"], [data-mp-refresh], [data-mp-retry]').forEach(b => { b.disabled = busy; });
      });
    };
    const clearErrors = () => {
      state.failed = false;
      panels.forEach(p => { p.querySelector('[data-mp-query-error]').hidden = true; p.querySelector('[data-mp-initial-error]')?.remove(); });
    };
    const hidePrivateData = () => {
      root.querySelectorAll('[data-mp-record-list], [data-mp-private-profile]').forEach(el => { el.replaceChildren(); });
      root.querySelectorAll('[data-mp-empty], [data-mp-no-matches], [data-mp-load]').forEach(el => { el.hidden = true; });
      root.querySelectorAll('#mp-account-name, #mp-account-email, #mp-account-order, #mp-account-message').forEach(el => { el.value = ''; });
    };
    const showError = (key, panel) => {
      state.failed = true;
      setStatus('');
      if (key === 'session_expired') hidePrivateData();
      const targets = panel ? [panel] : panels;
      targets.forEach(p => {
        const error = p.querySelector('[data-mp-query-error]');
        error.querySelector('[data-mp-error-text]').textContent = message(key);
        error.querySelector('[data-mp-retry]').hidden = key === 'session_expired' || !state.key;
        error.hidden = false;
        p.querySelector('[data-mp-no-matches]')?.setAttribute('hidden', '');
      });
    };
    const applyFilters = () => {
      panels.forEach(p => {
        const query = normalize(p.querySelector('[data-mp-search]').value);
        const filter = p.querySelector('[data-mp-filter]')?.value || 'all';
        const records = [...p.querySelectorAll('[data-mp-record]')];
        let count = 0;
        records.forEach(record => {
          const matches = (p.dataset.exactOrder ? record.dataset.orderName === p.dataset.exactOrder : normalize(record.dataset.search).includes(query)) && (filter === 'all' || record.dataset.orderState === filter || (filter === 'fulfilled' && record.dataset.orderState === 'complete'));
          record.hidden = !matches;
          if (matches) count++;
        });
        const empty = p.querySelector('[data-mp-empty]');
        if (empty) empty.hidden = state.total !== 0 || state.failed;
        const noMatches = p.querySelector('[data-mp-no-matches]');
        if (noMatches) noMatches.hidden = count > 0 || state.total === 0 || Boolean(state.next) || state.failed || state.busy;
        const more = p.querySelector('[data-mp-load]');
        if (more) more.hidden = !state.next;
        if (state.key && !state.busy && !state.failed) p.querySelector('[data-mp-query-status]').textContent = state.total === 0 ? '' : message(state.next ? 'results_partial' : 'results').replace('{count}', String(count)).replace('{total}', String(state.total));
      });
    };
    const fetchPage = async (pageUrl, replace = false) => {
      if (!navigator.onLine) throw new Error('offline');
      const url = new URL(pageUrl || currentUrl('orders'), location.origin);
      if (url.origin !== location.origin) throw new Error('load_error');
      url.hash = '';
      url.searchParams.set('view', 'account');
      url.searchParams.set('section_id', root.dataset.sectionId);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      state.controller = new AbortController();
      const timer = setTimeout(() => state.controller?.abort(), 12000);
      let doc;
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: state.controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(response.status === 429 ? 'rate_limited' : 'load_error');
        doc = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-mp-account-root]');
      } finally { clearTimeout(timer); state.controller = null; }
      if (!doc) throw new Error('load_error');
      if (!doc.dataset.customerKey || doc.dataset.customerKey !== state.key) throw new Error('session_expired');
      const incomingTotal = Number(doc.dataset.orderCount);
      if (!Number.isFinite(incomingTotal) || (incomingTotal > 0 && !doc.querySelector('[data-mp-record]'))) throw new Error('load_error');
      const next = doc.querySelector('[data-mp-pagination]')?.dataset.nextUrl || '';
      if (next && next === state.next && !replace) throw new Error('load_error');
      panels.forEach(p => {
        const list = p.querySelector('[data-mp-record-list]');
        const incoming = doc.querySelector(`[data-mp-query="${p.dataset.mpQuery}"] [data-mp-record-list]`);
        if (!list || !incoming) throw new Error('load_error');
        if (replace) list.replaceChildren();
        const ids = new Set([...list.children].map(r => r.dataset.orderId));
        [...incoming.children].forEach(r => { if (!ids.has(r.dataset.orderId)) list.append(document.importNode(r, true)); });
      });
      if (replace) {
        const target = root.querySelector('[data-mp-private-profile]');
        const source = doc.querySelector('[data-mp-private-profile]');
        if (target && source) target.replaceChildren(...[...source.childNodes].map(n => document.importNode(n, true)));
      }
      state.next = next;
      state.total = incomingTotal;
    };
    const run = async (kind = 'search', resume = false) => {
      if (state.busy || !state.key) return;
      state.retry = () => run(kind, resume);
      clearErrors();
      setBusy(true);
      setStatus(message('loading'));
      const started = Date.now();
      try {
        if (kind === 'refresh' || (kind === 'search' && !resume)) {
          await fetchPage(currentUrl('orders'), true);
          resume = true;
        }
        const hasQuery = panels.some(p => p.querySelector('[data-mp-search]').value.trim() || (p.querySelector('[data-mp-filter]')?.value || 'all') !== 'all');
        if (kind === 'more' && state.next) await fetchPage(state.next);
        if (kind === 'search' || hasQuery) {
          while (state.next) {
            if (Date.now() - started > 45000) throw new Error('search_incomplete');
            await fetchPage(state.next);
            setStatus(message('loading'));
          }
        }
      } catch (error) {
        const key = error.name === 'AbortError' ? 'timeout' : ['offline','rate_limited','session_expired','search_incomplete'].includes(error.message) ? error.message : 'load_error';
        showError(key);
      } finally { setBusy(false); applyFilters(); }
    };
    root.querySelectorAll('[data-mp-sign-in]').forEach(link => {
      const url = new URL('/customer_authentication/login', location.origin);
      const dest = currentUrl(link.dataset.mode || 'orders');
      url.searchParams.set('return_to', dest.pathname + dest.search + dest.hash);
      link.href = url.href;
    });
    panels.forEach(p => {
      const form = p.querySelector('[data-mp-query-form]');
      p.querySelector('[data-mp-search]').addEventListener('input', () => { delete p.dataset.exactOrder; });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        if (state.key) { run(); return; }
        if (!navigator.onLine) { showError('offline', p); return; }
        try { sessionStorage.setItem(storageKey, JSON.stringify({ mode: p.dataset.mpQuery, query: p.querySelector('[data-mp-search]').value.trim(), time: Date.now() })); } catch {}
        const login = new URL('/customer_authentication/login', location.origin);
        const dest = currentUrl(p.dataset.mpQuery);
        login.searchParams.set('return_to', dest.pathname + dest.search + dest.hash);
        login.searchParams.set('login_hint', form.elements.login_hint.value.trim());
        p.querySelector('[data-mp-query-status]').textContent = message('redirecting');
        location.assign(login.href);
        setTimeout(() => showError('sign_in_problem', p), 12000);
      });
      p.querySelector('[data-mp-filter]')?.addEventListener('change', () => run());
    });
    root.addEventListener('click', async event => {
      const target = event.target.closest('button, a');
      if (!target || !root.contains(target)) return;
      if (target.matches('[data-mp-refresh]')) run('refresh');
      if (target.matches('[data-mp-retry]')) state.retry?.();
      if (target.matches('[data-mp-load]')) { event.preventDefault(); run('more'); }
      if (target.matches('[data-mp-reset]')) {
        const p = target.closest('[data-mp-query]');
        delete p.dataset.exactOrder;
        p.querySelector('[data-mp-search]').value = '';
        if (p.querySelector('[data-mp-filter]')) p.querySelector('[data-mp-filter]').value = 'all';
        p.querySelector('[data-mp-search]').focus();
        if (state.failed) run(); else applyFilters();
      }
      if (target.matches('[data-mp-track-order], [data-mp-view-order]')) {
        const mode = target.hasAttribute('data-mp-track-order') ? 'tracking' : 'orders';
        const p = panels.find(p => p.dataset.mpQuery === mode);
        p.querySelector('[data-mp-search]').value = target.dataset.mpTrackOrder || target.dataset.mpViewOrder;
        p.dataset.exactOrder = p.querySelector('[data-mp-search]').value;
        if (p.querySelector('[data-mp-filter]')) p.querySelector('[data-mp-filter]').value = 'all';
        await run();
        if (mode === 'orders') p.querySelectorAll('[data-mp-record]:not([hidden]) details').forEach(d => { d.open = true; });
      }
      if (target.matches('[data-mp-support-order]')) {
        const order = root.querySelector('#mp-account-order');
        if (order) order.value = target.dataset.mpSupportOrder;
        const topic = root.querySelector('#mp-account-topic');
        if (topic) topic.value = 'Order support';
        root.querySelector('#mp-account-message')?.focus({ preventScroll: true });
      }
      if (target.matches('[data-mp-copy]')) {
        const p = target.closest('[data-mp-query]');
        try {
          await navigator.clipboard.writeText(target.dataset.mpCopy);
          p.querySelector('[data-mp-query-status]').textContent = message('copied');
        } catch { p.querySelector('[data-mp-query-status]').textContent = message('copy_error'); }
      }
      if (target.matches('[data-mp-sign-in]')) {
        const mode = target.dataset.mode || 'orders';
        const p = panels.find(p => p.dataset.mpQuery === mode);
        try { sessionStorage.setItem(storageKey, JSON.stringify({ mode, query: p.querySelector('[data-mp-search]').value.slice(0,100), time: Date.now() })); } catch {}
      }
    });
    const support = root.querySelector('form#mp-account-request');
    if (support) {
      const feedback = root.querySelector('[data-mp-support-feedback]');
      support.addEventListener('submit', event => {
        if (!support.reportValidity()) { event.preventDefault(); return; }
        if (!navigator.onLine) { event.preventDefault(); feedback.textContent = message('offline'); feedback.hidden = false; feedback.focus(); return; }
        const submit = support.querySelector('[type="submit"]');
        if (submit.disabled) { event.preventDefault(); return; }
        submit.disabled = true;
        feedback.textContent = message('sending'); feedback.hidden = false;
        setTimeout(() => { submit.disabled = false; feedback.textContent = message('support_unconfirmed'); }, 20000);
      });
    }
    window.addEventListener('offline', () => showError('offline'));
    window.addEventListener('pageshow', event => { if (event.persisted && state.key) { hidePrivateData(); run('refresh'); } });
    window.addEventListener('pagehide', () => state.controller?.abort());
    const scrollToHash = () => {
      const allowed = ['#orders','#tracking','#after-sales','#profile','#help'];
      if (allowed.includes(location.hash)) {
        const panel = root.querySelector(location.hash);
        const heading = panel?.querySelector('h2');
        if (heading) {
          const headerHeight = document.querySelector('.mp-header-shell')?.getBoundingClientRect().height || 80;
          window.scrollTo({ top: Math.max(0, window.scrollY + heading.getBoundingClientRect().top - headerHeight - 24), behavior: 'instant' });
          heading.focus({ preventScroll: true });
        }
      }
    };
    window.addEventListener('hashchange', scrollToHash);
    let intent;
    try {
      intent = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      sessionStorage.removeItem(storageKey);
    } catch {}
    if (intent && Date.now() - intent.time < 900000 && ['orders','tracking'].includes(intent.mode)) {
      const p = panels.find(p => p.dataset.mpQuery === intent.mode);
      p.querySelector('[data-mp-search]').value = String(intent.query || '').slice(0,100);
      if (state.key) run(); else showError('sign_in_problem', p);
    }
    applyFilters();
    if (root.querySelector('[data-mp-initial-error]')) { state.retry = () => run('refresh'); showError('load_error'); }
    requestAnimationFrame(scrollToHash);
  };
  const start = () => document.querySelectorAll('[data-mp-account-root]').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-interface-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const bag = document.getElementById('mp-cart-form');
    if (bag && !bag.dataset.mpInterfaceBound) {
      bag.dataset.mpInterfaceBound = 'true';
      const status = bag.querySelector('[data-mp-bag-status]');
      const initial = status?.textContent;
      const update = () => {
        const changed = [...bag.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.defaultValue);
        bag.dataset.mpDirty = String(changed);
        if (status) status.textContent = changed ? status.dataset.mpDirtyMessage : initial;
      };
      bag.addEventListener('input', update);
      bag.addEventListener('change', update);
    }
    document.querySelector('[data-mp-form-error], [data-mp-form-success]')?.focus({preventScroll:false});
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const initNavigation = () => document.querySelectorAll('[data-mp-navigation]:not([data-mp-menu-bound])').forEach(nav => {
    nav.dataset.mpMenuBound = 'true';
    const disclosure = nav.querySelector('.mp-nav-disclosure');
    const main = nav.querySelector('[data-mp-nav-main]');
    const panel = nav.querySelector('.mp-menu-panel');
    const tablist = nav.querySelector('[data-mp-menu-tabs]');
    const tabs = [...nav.querySelectorAll('[data-mp-menu-tab]')];
    const panels = [...nav.querySelectorAll('[data-mp-menu-panel]')];
    const familyLinks = [...nav.querySelectorAll('[data-mp-nav-family]')];
    const explore = nav.querySelector('[data-mp-explore]');
    const exploreTrigger = nav.querySelector('[data-mp-nav-explore]');
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const defaultCategory = tabs[0].dataset.mpMenuTab;
    let category = defaultCategory;
    let opener = main;
    let openTimer;
    let closeTimer;
    let tabTimer;
    let contentAnimation;
    let exploreTimer;
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', nav.querySelector('.mp-menu-label').textContent);
    tablist.setAttribute('aria-orientation', 'vertical');
    tabs.forEach(tab => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', nav.querySelector('[data-mp-menu-panel="' + tab.dataset.mpMenuTab + '"]').id);
    });
    panels.forEach(item => {
      item.setAttribute('role', 'tabpanel');
      item.setAttribute('aria-labelledby', nav.querySelector('[data-mp-menu-tab="' + item.dataset.mpMenuPanel + '"]').id);
    });
    const syncTop = () => {
      main.setAttribute('aria-expanded', String(disclosure.open));
      main.dataset.mpActive = String(disclosure.open && opener === main);
      familyLinks.forEach(link => {
        const active = disclosure.open && opener !== main && link.dataset.mpNavFamily === category;
        link.dataset.mpActive = String(active);
        link.setAttribute('aria-expanded', String(active));
      });
      if (disclosure.open && !familyLinks.some(link => link.dataset.mpNavFamily === category)) main.dataset.mpActive = 'true';
    };
    const selectCategory = (key, animate = true) => {
      const index = tabs.findIndex(tab => tab.dataset.mpMenuTab === key);
      if (index < 0) return;
      const changed = category !== key;
      category = key;
      tablist.style.setProperty('--mp-menu-index', String(index));
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach(item => item.hidden = item.dataset.mpMenuPanel !== key);
      syncTop();
      contentAnimation?.cancel();
      if (changed && animate && !reduceMotion.matches) {
        contentAnimation = panels[index].animate([{opacity:.3, transform:'translateY(7px)'}, {opacity:1, transform:'translateY(0)'}], {duration:220, easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    };
    const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); clearTimeout(tabTimer); };
    const closeMenu = (restoreFocus = false) => {
      clearTimers();
      disclosure.open = false;
      syncTop();
      if (restoreFocus) opener.focus();
    };
    const openMenu = (key, trigger, focus = false) => {
      clearTimers();
      clearTimeout(exploreTimer);
      explore.open = false;
      opener = trigger;
      const wasOpen = disclosure.open;
      disclosure.open = true;
      selectCategory(key, wasOpen);
      if (!wasOpen && !reduceMotion.matches) panel.animate([{opacity:0, transform:'translateY(-6px)'}, {opacity:1, transform:'translateY(0)'}], {duration:200, easing:'ease-out'});
      if (focus) tabs.find(tab => tab.dataset.mpMenuTab === key)?.focus();
    };
    selectCategory(defaultCategory, false);
    disclosure.addEventListener('toggle', () => { syncTop(); if (!disclosure.open) clearTimers(); });
    main.addEventListener('click', () => { opener = main; clearTimers(); explore.open = false; selectCategory(defaultCategory, false); });
    [main, ...familyLinks].forEach(trigger => {
      const key = trigger.dataset.mpNavFamily || defaultCategory;
      trigger.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        clearTimers();
        openTimer = setTimeout(() => openMenu(key, trigger), 150);
      });
      trigger.addEventListener('pointerleave', () => clearTimeout(openTimer));
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        openMenu(key, trigger, true);
      });
    });
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        clearTimers();
        if (category === tab.dataset.mpMenuTab) return;
        event.preventDefault();
        selectCategory(tab.dataset.mpMenuTab);
      });
      tab.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        if (tablist.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
        clearTimeout(tabTimer);
        tabTimer = setTimeout(() => selectCategory(tab.dataset.mpMenuTab), 120);
      });
      tab.addEventListener('pointerleave', () => clearTimeout(tabTimer));
      tab.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); selectCategory(tab.dataset.mpMenuTab); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); panels[index].querySelector('a')?.focus(); return; }
        if (!['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
        clearTimers();
        selectCategory(tabs[next].dataset.mpMenuTab);
        tabs[next].focus();
      });
    });
    nav.querySelector('[data-mp-menu-close]').addEventListener('click', () => closeMenu(true));
    nav.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || (!disclosure.open && !explore.open)) return;
      event.preventDefault();
      if (explore.open) { explore.open = false; exploreTrigger.focus(); }
      else closeMenu(true);
    });
    nav.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    nav.addEventListener('pointerleave', () => {
      clearTimeout(openTimer);
      if (finePointer.matches && !panel.contains(document.activeElement)) closeTimer = setTimeout(() => closeMenu(), 240);
      if (finePointer.matches && !explore.contains(document.activeElement)) exploreTimer = setTimeout(() => { explore.open = false; }, 240);
    });
    nav.addEventListener('focusout', event => { if (event.relatedTarget && !nav.contains(event.relatedTarget)) { closeMenu(); explore.open = false; } });
    exploreTrigger.addEventListener('pointerenter', () => {
      if (!finePointer.matches) return;
      clearTimers();
      clearTimeout(exploreTimer);
      closeMenu();
      explore.open = true;
    });
    exploreTrigger.addEventListener('click', event => {
      if (finePointer.matches && explore.open && event.detail > 0) event.preventDefault();
    });
    explore.addEventListener('pointerleave', () => {
      if (finePointer.matches && !explore.contains(document.activeElement)) exploreTimer = setTimeout(() => { explore.open = false; }, 180);
    });
    explore.addEventListener('pointerenter', () => clearTimeout(exploreTimer));
    explore.addEventListener('toggle', () => { if (explore.open) closeMenu(); });
    exploreTrigger.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      explore.open = true;
      explore.querySelector('.mp-explore-menu a')?.focus();
    });
    const desktop = matchMedia('(min-width: 761px)');
    desktop.addEventListener('change', () => { if (!desktop.matches) { closeMenu(); explore.open = false; } });
    reduceMotion.addEventListener('change', () => { if (reduceMotion.matches) { contentAnimation?.cancel(); panel.getAnimations().forEach(animation => animation.cancel()); } });
  });
  initNavigation();
  document.addEventListener('shopify:section:load', initNavigation);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-product-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('.mp-pdp .mp-quantity:not([data-mp-quantity-ready])').forEach(group => {
      const input = group.querySelector('input');
      const minus = group.querySelector('[data-mp-qty="-1"]');
      const plus = group.querySelector('[data-mp-qty="1"]');
      if (!input || !minus || !plus) return;
      const sync = () => {minus.setAttribute('aria-disabled',String(Number(input.value) <= Number(input.min || 1)));plus.setAttribute('aria-disabled',String(!!input.max && Number(input.value) >= Number(input.max)));};
      input.addEventListener('input',sync);
      input.addEventListener('change',sync);
      group.dataset.mpQuantityReady = 'true';
      sync();
    });
  };
  setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
